import { PanelResizeHandle } from "react-resizable-panels";
import { ResizeIcon } from "common/icons/ResizeIcon";
import styles from "./panelResizeDivider.module.scss";

export const PanelResizeDivider = () => (
  <PanelResizeHandle
    className={styles.panelResizeDivider}
    hitAreaMargins={{ coarse: 15, fine: 10 }}
  >
    <div className={styles.panelResizeDivider__iconWrapper}>
      <ResizeIcon />
    </div>
  </PanelResizeHandle>
);
